import React, { Component } from "react";
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, onAuthStateChanged } from "firebase/auth";
import {
  getFirestore,
  collection,
  doc,
  getDoc,
  query,
  where,
  orderBy,
  onSnapshot,
  setDoc,
  getDocs,
} from "firebase/firestore";
import { getStorage, ref as storageRef } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getAnalytics, logEvent } from "firebase/analytics";
import CircularProgress from "@material-ui/core/CircularProgress";
import Scroll from "react-scroll";
import { FirebaseConfig } from "./firebase/config";
import moment from "moment";
import "moment/locale/ja";

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

// Firebase アプリを初期化
const app = initializeApp(FirebaseConfig);

// アナリティクス設定
const analytics = getAnalytics(app);
const createBrowserHistory = require("history").createBrowserHistory;
const history = createBrowserHistory();
history.listen(({ pathname }) => {
  logEvent(analytics, "page_view");
});

// Firebase 各機能の初期化
const auth = getAuth(app);
const auth2 = auth;
const googleauth = new GoogleAuthProvider();
const storage = getStorage(app);
const db = getFirestore(app);
const functions = getFunctions(app, "asia-northeast1");
const SScroller = Scroll.scroller;
const AScroller = Scroll.animateScroll;

class RouterDiv extends Component {
  state = {
    user: null,
    auth: auth,
    auth2: auth2,
    localuser: null,
    googleauth: googleauth,
    accessToken: null,
    headerShow: false,
    messageShow: false,
    usercollection: null,
    coursecollection: null,
    userstorage: null,
    coursestorage: null,
    userscourse: null,
    qualitification: null,
    userQualification: null,
    openContent: false,
    isAutoLogin: false,
    prevpath: null,
    contentWindow: null,
    course: null,
    Header: null,
    Footer: null,
    Login: null,
    Detail: null,
    Questionnaire: null,
    Setting: null,
    TopPage: null,
    NoMatch: null,
    Qualification: null,
    Content: null,
    MailAction: null,
    TermsPage: null,
    PayResultPage: null,
    AdminPage: null,
    DiplomaPage: null,
    HelpPage: null,
    BasicPage: null,
    MaintenancePage: null,
    userAnswerData: [],
    basicValue: null,
    basicInput: false,
  };

  userData = null;
  userQualification = null;
  Qualifications = null;
  userAnswerData = null;

  fetchData = async () => {
    const [
      Header,
      Footer,
      Login,
      UserPage,
      Detail,
      Questionnaire,
      Setting,
      TopPage,
      NoMatch,
      Qualification,
      Content,
      MailAction,
      TermsPage,
      PayResultPage,
      AdminPage,
      DiplomaPage,
      HelpPage,
      BasicPage,
      MaintenancePage,
    ] = await Promise.all([
      import("./component/Header"),
      import("./component/Footer"),
      import("./Pages/LoginAtom"),
      import("./Pages/UserPage"),
      import("./Pages/CourseDetail"),
      import("./Pages/Questionnaire"),
      import("./Pages/UserSetting"),
      import("./Pages/TopPage"),
      import("./Pages/NoMatch"),
      import("./Pages/Qualification"),
      import("./Pages/Content"),
      import("./Pages/MailAction"),
      import("./Pages/Tearms"),
      import("./Pages/PayResult"),
      import("./Pages/Admin"),
      import("./Pages/Diploma"),
      import("./Pages/Help"),
      import("./Pages/BasicPage"),
      import("./Pages/MaintenancePage"),
    ]);
    this.setState({
      Header: Header.default,
      Footer: Footer.default,
      Login: Login.default,
      UserPage: UserPage.default,
      Detail: Detail.default,
      Questionnaire: Questionnaire.default,
      Setting: Setting.default,
      TopPage: TopPage.default,
      NoMatch: NoMatch.default,
      Qualification: Qualification.default,
      Content: Content.default,
      MailAction: MailAction.default,
      TermsPage: TermsPage.default,
      PayResultPage: PayResultPage.default,
      AdminPage: AdminPage.default,
      DiplomaPage: DiplomaPage.default,
      HelpPage: HelpPage.default,
      BasicPage: BasicPage.default,
      MaintenancePage: MaintenancePage.default,
    });
  };
  componentDidMount() {
    this.fetchData();
    //const agent = window.navigator.userAgent.toLowerCase();
    //const ie11 = agent.indexOf("trident/7") !== -1;

    // ログイン状態監視
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        this.setState({ isAutoLogin: true });
        const userRef = doc(db, "users", user.uid);
        const userStorageRef = storageRef(storage, `/users/${user.uid}`);
        try {
          const userdata = await getDoc(userRef);
          if (!userdata.exists()) {
            // 初回ログイン　かつ　ユーザ登録してから
            const groupsQuery = query(
              collection(db, "groups"),
              where("default", "==", true)
            );
            const groupsDefault = await getDocs(groupsQuery);
            let groups = {};
            groupsDefault.forEach((doc) => {
              const data = doc.data();
              if (!data.nogroup) {
                groups[doc.id] = true;
              }
            });
            const defaultUserSettings = {
              area: "",
              birthday: null,
              email: user.email,
              gender: "",
              job: "",
              romaname: "",
              kananame: "",
              name: "",
              sports: "",
              groups,
              occupation: {},
              experience: {},
              position: {},
              industry: [],
              mainarea: {},
              lastlogin: moment(new Date()).unix(),
            };
            await userRef.set(defaultUserSettings, { merge: true });
            this.setState({
              usercollection: defaultUserSettings,
              userscourse: userRef,
              userstorage: userStorageRef,
            });
          } else {
            await setDoc(
              userRef,
              { lastlogin: moment(new Date()).unix() },
              { merge: true }
            );
            this.setState({
              usercollection: { id: userdata.id, ...userdata.data() },
              userscourse: userRef,
              userstorage: userStorageRef,
            });
          }

          // setting の情報を取得
          const basicRef = doc(db, "setting", "basic");
          const basicData = await getDoc(basicRef);
          if (basicData.exists()) {
            const basicValue = basicData.data().value;
            this.setState({ basicValue });
          }

          // ユーザデータ更新監視
          this.userData = onSnapshot(userRef, (doc) => {
            this.setState({ usercollection: doc.data() });
          });

          // 資格データ更新監視
          this.Qualifications = onSnapshot(
            query(collection(db, "qualification"), orderBy("qid", "asc")), // クエリを作成
            (qsnapshot) => {
              let qualitification = [];
              if (!qsnapshot.empty) {
                // コレクションが空でないか確認
                qsnapshot.forEach((doc) => {
                  qualitification.push({ id: doc.id, ...doc.data() });
                });
              }
              this.setState({
                qualitification,
              });
            }
          );

          // ユーザ資格データ更新監視
          this.userQualification = onSnapshot(
            collection(db, "usersqualification"), // コレクション参照を作成
            (uqsnapshot) => {
              let userQualification = [];
              if (!uqsnapshot.empty) {
                // コレクションが空でないか確認
                uqsnapshot.forEach((doc) => {
                  userQualification.push({ id: doc.id, ...doc.data() });
                });
              }
              this.setState({
                userQualification,
              });
            }
          );

          // ユーザアンサーデータ更新監視
          this.userAnswerData = onSnapshot(
            query(
              collection(db, "answer"), // コレクション参照
              where("uid", "==", user.uid) // 条件を追加
            ),
            (udsnapshot) => {
              let userAnswerData = [];
              if (!udsnapshot.empty) {
                // コレクションが空でないか確認
                udsnapshot.forEach((doc) => {
                  userAnswerData.push({
                    id: doc.id,
                    ...doc.data(),
                  });
                });
              }
              this.setState({
                userAnswerData,
              });
            }
          );

          if (!user.emailVerified && !this.state.usercollection.admin) {
            this.setState({
              messageShow: true,
              isAutoLogin: false,
            });
            return;
          }
          this.setState({
            user: user,
            isAutoLogin: false,
          });
          //analytics.setUserId(user.uid);
        } catch (error) {
          console.log(error);
          this.setState({
            isAutoLogin: false,
          });
        }
      } else {
        if (this.userData) this.userData();
        if (this.Qualifications) this.Qualifications();
        if (this.userQualification) this.userQualification();
        if (this.userAnswerData) this.userAnswerData();
        this.setState({
          user: null,
          localuser: null,
          usercollection: null,
          coursecollection: null,
          userscourse: null,
          userstorage: null,
          userQualification: null,
          userAnswerData: [],
          isAutoLogin: false,
        });
      }
    });
  }

  componentWillUnmount() {
    this.setState({
      localuser: null,
      basicValue: null,
      basicInput: false,
    });
  }

  alertLogin = () => {
    console.log("alertLogin");
    if (!this.state.user || !this.state.usercollection) {
      return alert("ログインが必要です。");
    }
    if (
      this.state.usercollection.name === "" ||
      this.state.usercollection.kananame === "" ||
      this.state.usercollection.romaname === ""
    ) {
      return alert("ユーザ情報が未設定です。");
    }
  };

  openContentPage(course, history, location) {
    if (!this.state.user) {
      return alert("ログインが必要です。");
    }
    if (
      this.state.usercollection.name === "" ||
      this.state.usercollection.kananame === "" ||
      this.state.usercollection.romaname === ""
    ) {
      return alert("ユーザ情報が未設定です。");
    }
    if (this.state.contentWindow) {
      this.state.contentWindow.close();
    }
    const agent = window.navigator.userAgent.toLowerCase();
    //const ie11 = true; // ２画面での対応
    const ie11 = agent.indexOf("trident/7") !== -1;
    console.log("openContentPage:ie11", ie11);
    const nowContent = ie11
      ? null
      : window.open(
          course.contents,
          "_blank",
          "menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,width=1280,height=720"
        );
    //const nowContent = window.open(course.contents, '_blank'); // 2画面での対応
    this.setState({
      contentWindow: nowContent,
      openContent: true,
      course: course,
      prevpath: location,
    });
    history.push(`/member/user/contents/${course.id}`);
  }

  closeContentPage = (history) => (event) => {
    // console.log("Close")
    history.replace(this.state.prevpath);
    this.setState({
      openContent: false,
      course: null,
      prevpath: null,
    });
  };

  setUserConfig(config) {
    this.setState({
      localuser: config,
    });
  }

  headerSpy(bool) {
    this.setState({
      headerShow: bool,
    });
  }

  gotoUserPage = (history) => async (e) => {
    await history.push("/member/user");
    await window.location.reload();
  };

  messageHide = () => {
    this.setState({
      messageShow: false,
    });
  };

  scrollTo =
    (name = null) =>
    (event) => {
      if (name) {
        SScroller.scrollTo(name, {
          smooth: true,
          offset: -62,
          duration: 400,
        });
      } else {
        AScroller.scrollTo(0);
      }
    };

  basicInputExec = async (text) => {
    console.log(text);
    console.log("this.state.basicValue", this.state.basicValue);

    // setting の情報を取得
    if (!this.state.basicValue) {
      const basicRef = doc(db, "setting", "basic"); // ドキュメント参照
      const basicData = await getDoc(basicRef); // ドキュメントを取得

      if (basicData.exists()) {
        // ドキュメントが存在するか確認
        const basicValue = basicData.data().value; // 値を取得
        if (text === basicValue) {
          this.setState({
            basicInput: true,
            basicValue,
          });
        } else {
          this.setState({
            basicValue,
          });
        }
      }
    } else {
      if (text === this.state.basicValue) {
        this.setState({
          basicInput: true,
        });
      }
    }
  };

  render() {
    const {
      Header,
      Footer,
      Login,
      UserPage,
      Detail,
      Setting,
      NoMatch,
      Qualification,
      Content,
      MailAction,
      TermsPage,
      PayResultPage,
      AdminPage,
      DiplomaPage,
      HelpPage,
      BasicPage,
      MaintenancePage,
      openContent,
      qualitification,
      //usersCourseData,
      userQualification,
      //usersdiploma,
      Questionnaire,
      userAnswerData,
    } = this.state;

    let isMaintenance = false; // メンテナンスモード
    if (Header && Footer && isMaintenance) {
      return (
        <Router>
          <MaintenancePage />
        </Router>
      );
    }

    let isSpeedEnv = false;
    if (isSpeedEnv && Header && !this.state.basicInput) {
      return (
        <Router>
          <BasicPage basicInputExec={this.basicInputExec} />
        </Router>
      );
    }

    if (Header) {
      return (
        <Router>
          <div style={{ height: "100%", position: "relative" }}>
            <Header
              user={this.state.user}
              auth={this.state.auth}
              headershow={this.state.headerShow}
              localuser={this.state.usercollection}
              isAutoLogin={this.state.isAutoLogin}
              scrollTo={this.scrollTo}
            />
            <Switch>
              <Route
                exact
                path="/"
                render={(props) => {
                  return this.state.user ? (
                    <Redirect
                      to={{
                        pathname: "/member/user",
                      }}
                    />
                  ) : (
                    <Login
                      messageShow={this.state.messageShow}
                      messageHide={this.messageHide}
                      googleauth={this.state.googleauth}
                      isAutoLogin={this.state.isAutoLogin}
                    />
                  );
                }}
              />

              <Route
                exact
                path="/help"
                render={(props) => {
                  return <HelpPage {...props} />;
                }}
              />

              <Route
                exact
                path="/member/login"
                render={(props) => {
                  return this.state.user ? (
                    <Redirect
                      to={{
                        pathname: "/member/user",
                      }}
                    />
                  ) : (
                    <Login
                      messageShow={this.state.messageShow}
                      messageHide={this.messageHide}
                      googleauth={this.state.googleauth}
                      isAutoLogin={this.state.isAutoLogin}
                    />
                  );
                }}
              />

              <Route
                exact
                path="/member/user"
                render={(props) => {
                  return this.state.user ? (
                    <UserPage
                      auth={this.state.auth}
                      db={db}
                      userdata={this.state.userscourse}
                      user={this.state.user}
                      qualitification={qualitification}
                      userQualification={userQualification}
                      localuser={this.state.usercollection}
                      openContentPage={(id) => {
                        this.openContentPage(id, props.history, props.location);
                      }}
                      history={props.history}
                      alertLogin={this.alertLogin}
                      functions={functions}
                    />
                  ) : (
                    <Redirect
                      to={{
                        pathname: "/member/login",
                      }}
                    />
                  );
                }}
              />

              <Route
                exact
                path="/member/user/settings/:firstflg"
                render={(props) => {
                  return this.state.user ? (
                    <Setting
                      auth={this.state.auth}
                      auth2={auth2}
                      db={db}
                      localuser={this.state.usercollection}
                      user={this.state.user}
                      storage={storage}
                      //usersCourseData={usersCourseData}
                      qualitification={qualitification}
                      userQualification={userQualification}
                      functions={functions}
                      {...props}
                    />
                  ) : (
                    <Redirect
                      to={{
                        pathname: "/member/login",
                      }}
                    />
                  );
                }}
              />

              <Route
                exact
                path="/member/user/qualification/:qualificationId"
                render={(props) => {
                  return this.state.user ? (
                    <Qualification
                      auth={this.state.auth}
                      db={db}
                      user={this.state.user}
                      localuser={this.state.usercollection}
                      qualitification={qualitification}
                      userQualification={userQualification}
                      {...props}
                    />
                  ) : (
                    <Redirect
                      to={{
                        pathname: "/member/login",
                      }}
                    />
                  );
                }}
              />

              <Route
                exact
                path="/member/user/diploma/:diplomaId"
                render={(props) => {
                  return this.state.user ? (
                    <DiplomaPage
                      auth={this.state.auth}
                      db={db}
                      user={this.state.user}
                      localuser={this.state.usercollection}
                      qualitification={qualitification}
                      userQualification={userQualification}
                      //diploma={usersdiploma}
                      {...props}
                    />
                  ) : (
                    <Redirect
                      to={{
                        pathname: "/member/login",
                      }}
                    />
                  );
                }}
              />

              <Route
                exact
                path="/member/user/contents/:contentsId"
                render={(props) => {
                  return this.state.user && this.state.course ? (
                    <Content
                      open={openContent}
                      user={this.state.user}
                      db={db}
                      course={this.state.course}
                      contentWindow={this.state.contentWindow}
                      userAnswerData={userAnswerData}
                      closeContentPage={this.closeContentPage(props.history)}
                      functions={functions}
                      {...props}
                    />
                  ) : (
                    <Redirect
                      to={{
                        pathname: "/member/login",
                      }}
                    />
                  );
                }}
              />

              <Route
                exact
                path="/member/courses/:id"
                render={(props) => {
                  const { classes, ...other } = props;
                  return (
                    <Detail
                      auth={this.state.auth}
                      db={db}
                      user={this.state.user}
                      localuser={this.state.usercollection}
                      openContentPage={(id) => {
                        this.openContentPage(id, props.history, props.location);
                      }}
                      alertLogin={this.alertLogin}
                      //usersCourseData={usersCourseData}
                      qualitification={qualitification}
                      userQualification={userQualification}
                      //diploma={usersdiploma}
                      functions={functions}
                      {...other}
                    />
                  );
                }}
              />

              <Route
                exact
                path="/member/questionnaire/:courseId/:questionnaireId"
                render={(props) => {
                  const { classes, ...other } = props;
                  return this.state.auth ? (
                    <Questionnaire
                      auth={this.state.auth}
                      db={db}
                      user={this.state.user}
                      openContentPage={(id) => {
                        this.openContentPage(id, props.history, props.location);
                      }}
                      alertLogin={this.alertLogin}
                      userQualification={userQualification}
                      localuser={this.state.usercollection}
                      functions={functions}
                      {...other}
                    />
                  ) : (
                    <Redirect
                      to={{
                        pathname: "/member/login",
                      }}
                    />
                  );
                }}
              />

              <Route
                exact
                path="/member/termsofservice"
                render={(props) => {
                  const { classes, ...other } = props;
                  return <TermsPage {...other} />;
                }}
              />

              <Route
                exact
                path="/member/auth/action"
                render={(props) => {
                  const { classes, ...other } = props;
                  return (
                    <MailAction
                      auth={this.state.auth}
                      db={db}
                      user={this.state.user}
                      gotoUserPage={this.gotoUserPage}
                      {...other}
                    />
                  );
                }}
              />

              <Route
                exact
                path="/member/admin"
                render={(props) => {
                  const { classes, ...other } = props;
                  return this.state.user &&
                    this.state.usercollection &&
                    this.state.usercollection.admin ? (
                    <AdminPage
                      auth={this.state.auth}
                      localuser={this.state.usercollection}
                      storage={storage}
                      db={db}
                      user={this.state.user}
                      functions={functions}
                      {...other}
                    />
                  ) : (
                    <Redirect to={{ pathname: "/member/login" }} />
                  );
                }}
              />

              <Route
                exact
                path="/member/paysuccess"
                render={(props) => {
                  return <PayResultPage {...props} status="success" />;
                }}
              />

              <Route
                exact
                path="/member/payerror"
                render={(props) => {
                  return <PayResultPage {...props} status="error" />;
                }}
              />

              <Route
                exact
                path="/member/paycancel"
                render={(props) => {
                  return <PayResultPage {...props} status="cancel" />;
                }}
              />

              <Route
                exact
                path="/member/help"
                render={(props) => {
                  return <HelpPage {...props} />;
                }}
              />

              <Route
                render={(props) => {
                  return <NoMatch {...props} />;
                }}
              />
            </Switch>
            <Footer
              user={this.state.user}
              auth={this.state.auth}
              headershow={this.state.headerShow}
              localuser={this.state.usercollection}
              isAutoLogin={this.state.isAutoLogin}
              scrollTo={this.scrollTo}
            />
          </div>
        </Router>
      );
    } else {
      return <CircularProgress size={56} className="buttonProgress" />;
    }
  }
}

export default RouterDiv;
